import { Link } from 'react-router-dom';
import { hotComics } from '@/mocks/comics';

export default function HotRecommendSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm">大家都在看的精彩漫画</p>
          </div>
          <Link
            to="/category?filter=hot"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-product-shop>
          {hotComics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group relative bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-300 transition-all duration-200 hover:-translate-y-1"
            >
              {/* Rank Badge */}
              {index < 3 && (
                <div className={`absolute top-3 left-3 z-10 w-7 h-7 flex items-center justify-center rounded-lg text-xs font-bold text-white ${
                  index === 0 ? 'bg-red-500' : index === 1 ? 'bg-orange-500' : 'bg-amber-500'
                }`}>
                  {index + 1}
                </div>
              )}

              {/* Cover */}
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`${comic.title} - 奇妙漫画热门推荐`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-200"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-200">
                  <span className="inline-flex items-center gap-1 text-xs text-white bg-primary-500/90 px-2.5 py-1 rounded-full">
                    <i className="ri-play-circle-line text-xs"></i>
                    立即阅读
                  </span>
                </div>
              </div>

              {/* Info */}
              <div className="p-3 md:p-4">
                <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base line-clamp-1 mb-1.5">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-1 mb-2">{comic.author}</p>
                <div className="flex items-center justify-between">
                  <span className="flex items-center gap-1 text-xs text-amber-500">
                    <i className="ri-star-fill text-xs"></i>
                    {comic.rating}
                  </span>
                  <span className={`text-xs px-2 py-0.5 rounded-full ${
                    comic.status === '连载中'
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-accent-100 text-accent-700'
                  }`}>
                    {comic.status}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Mobile view more */}
        <div className="text-center mt-8 sm:hidden">
          <Link
            to="/category?filter=hot"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600"
          >
            查看更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}